import { useState, useEffect } from "react";

import { Card, Badge } from "react-bootstrap";

import doctor1 from "../../../assets/img/avatars/logo_unknown_doctor.jpg";

import authenticatedFetch from "../../../utils/fetch";
import getActivityDateTimeDisplay from "../../../utils/datetime";


const Feed = () => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    authenticatedFetch({
      path: "task/recentactivity/",
      successHandler: function(result) {
        setIsLoaded(true);
        setData(result);
      },
      errorHandler: function(error) {
        setIsLoaded(true);
        setError(error);
      }
    });
  }, [])

  function handleTaskClicked(e, taskId)
  {
    e.preventDefault();
    window.location = "/tasks?task=" + taskId;
  }

  function getTitle(activity)
  {
    var title = "";
    if (activity.providerFormattedName != null && activity.providerFormattedName.length > 0)
    {
      title = activity.providerFormattedName + " | ";
    }
    if (activity.practiceName != null && activity.practiceName.length > 0)
    {
      title += activity.practiceName + " | ";
    }
    if (activity.facilityName != null && activity.facilityName.length > 0)
    {
      title += activity.facilityName + " | ";
    }
    if (activity.hubName != null && activity.hubName.length > 0)
    {
      title += activity.hubName + " | ";
    }
    if (activity.carrierName != null && activity.carrierName.length > 0)
    {
      title += activity.carrierName + " | ";
    }

    if (activity.category != null && activity.category.label != null && activity.category.label.length > 0)
    {
      title += activity.category.label;
    }
    
    // Trim off trailing pipe
    if (title.endsWith(" | "))
    {
      title = title.substring(0, title.length - 3);
    }

    return title;
  }

  var activityList;
  if (error || !data)
  {
    activityList = <div className="d-flex">Something went wrong... please reload the page...</div>
  }
  else if (!isLoaded)
  {
    activityList = <div className="d-flex">Loading...</div>
  }
  else
  {
    activityList = data.map((activity, i) => {
      var notes = activity.notes;
      if (notes && notes.length > 312)
      {
        notes = notes.substring(0, 310) + "...";
      }
      if (notes && notes.length > 0) {
        // Replace 3+ newlines (with optional spaces between) with a single newline
        notes = notes.replace(/\n\s*\n\s*\n+/g, "\n\n");
        
        notes = notes.split("\n").map(function(item, idx) {
          return ( 
              <span key={idx}>
                  {item}
                  <br />
              </span>
            )
        });
      }

      return (
        <div key={activity.id}> 
            <div style={{cursor: "pointer"}} className="d-flex" onClick={(e) => {handleTaskClicked(e, activity.taskId)}}>
              <img
                src={activity.userPhotoUrl == null || activity.userPhotoUrl === '' ? doctor1 : activity.userPhotoUrl}
                width="36"
                height="36"
                className="rounded-circle me-2"
                alt={activity.userFormattedName}
              />
              <div className="flex-grow-1">
                <span style={{fontSize: '0.9em'}}>
                {getTitle(activity)}
                </span>
                <br />
                <strong><i style={{ wordBreak: "break-word", fontSize: "0.9em"}}>{notes}</i></strong>
                <span>{getActivityDateTimeDisplay(activity.created, false, false, false, true)}&nbsp;<small className="text-muted">by {activity.userFormattedName}</small></span>
                <br />
              </div>
            </div>
          <hr />
        </div>
      )
    }, this);
  }

return (
    <Card className="flex-fill w-100">
      <Card.Header style={{marginBottom: "-10px"}}>
        <Card.Title className="mb-0"><Badge bg="primary">Recent Task Activity</Badge></Card.Title>
      </Card.Header>
      <Card.Body>
        {activityList}
      </Card.Body>
    </Card>
  );
}
export default Feed;
